import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useTask(ticketId) {
  const { data, _error, isLoading, mutate } = useSWR(
    ticketId ? `/tickets/${ticketId}/tasks` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    tasks: data,
    isLoading,
    mutate: mutate,
  };
}

export default useTask;
